module.exports = '<svg width="19" height="32" viewBox="0 0 19 32"><path d="M4.918.477a1.493 1.493 0 0 0-2.189 0L.543 2.771a1.669 1.669 0 0 0 0 2.288l10.544 10.896L.457 26.944a1.673 1.673 0 0 0 0 2.291l2.189 2.294c.602.63 1.581.63 2.189 0l13.92-14.426a1.683 1.683 0 0 0 0-2.294L4.918.476z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/right-2.js
// module id = 1378
// module chunks = 14